import actions from './actions';
import mutations from './mutations';

const getDefaultState = () => ({
  salesOrderStatuses: [],
  salesOrderStatusesOutDated : true,
  purchaseOrderStatuses: [],
  purchaseOrderStatusesOutDated : true,
  invoiceStatuses: [],
  invoiceStatusesOutDated : true,
  invoiceNoticeStatuses: [],
  invoiceNoticeStatusesOutDated : true,
  packageStatuses : [],
  packageStatusesOutDated : true,
  creditNoteStatuses : [],
  creditNoteStatusesOutDated : true
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  mutations,
  getDefaultState,
};
